
import { ServiceType, AppointmentLocationMode } from "../../common/constants/common-basic-data";
import { GeoIPLocation } from "../../common/models/geo-ip-location.model";
import { Price } from "../../common/models/string-data.model";
import { JobType, CarJobCategory, JobStatus, JobAction } from "../constants/keep-basic-data";
import { JobItem } from "./job-item.model";
import { JobModif } from "./job-modif.model";

export class Job {

  jobId = "";

  serviceType: ServiceType = ServiceType.EXCHANGE
  jobType: JobType = JobType.INSPECTION
  itemJobTypes: JobType[] = [];

  jobCategories: CarJobCategory [] = [];

  offerId = ""
  offerTitle = ""
  offerDescription = ""
  offerPosted = false
  offerClosed = false
  offerStartDate = ""
  offerEndDate = ""

  customerId = "";
  customerName = "";
  customerBusinessName = "";
  customerCountry = "";
  customerCity = "";

  providerId = "";
  providerName = "";
  providerBusinessName = "";
  providerCountry = "";
  providerCity = "";

  carId = "";
  carMake = "";
  carModel = "";
  carVersion = "";
  carYear = 0;
  carMileage = 0;

  title = "";
  description = "";
  status: JobStatus = JobStatus.DRAFT;

  scheduledDate = "";
  price: Price = Price.getDefault();

  details: string = "";
  locationMode: AppointmentLocationMode = AppointmentLocationMode.SELLER_LOCATION;
  location: GeoIPLocation = new GeoIPLocation();
  city: string = '';
  country: string = '';
  
  appointmentDate: string = "";
  rescheduleDate: string = "";

  needCallback: boolean = false;
  emergency: boolean = false;

  jobItems: JobItem [] = [];
  appointments: string[] = [];

  completedPrice: Price= Price.getDefault();
  completedDate = "";
  completedNotes = "";

  created = "";
  lastUpdated = "";
  createdBy = "";
  lastUpdatedBy = "";

  dealerActions: JobAction[] = [];
  modification?: JobModif = new JobModif();

  constructor(){
    this.itemJobTypes = [];
    this.jobItems = []; 
    this.appointments = [];
    this.jobCategories = [];

    this.dealerActions = [] ;
  }
}
